// eslint-disable-next-line import/no-extraneous-dependencies
import { Suspense } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import Authorization from '@layouts/Authorization/Authorization'
import PublicPageLayout from '@layouts/PageLayout/PublicPageLayout'
import Register from '@layouts/Authorization/Forms/Register/Register'
import Login from '@layouts/Authorization/Forms/Login/Login'
import PageNotFound from '@layouts/PageNotFound/PageNotFound'
import ResetPin from '@/layouts/Authorization/Forms/ResetPin/ResetPin'

function App() {
  return (
    <PublicPageLayout>
      <Authorization>
        <Suspense fallback={<div>Loading...</div>}>
          <Outlet />
        </Suspense>
      </Authorization>
    </PublicPageLayout>
  )
}

export const publicRoutes = [
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: <Login />
      },
      {
        path: '/login',
        element: <Login />
      },
      {
        path: '/reset-pin',
        element: <ResetPin />
      },
      {
        path: '/register/:token',
        element: <Register />
      }
    ]
  },
  { path: '/not-found', element: <PageNotFound /> },
  { path: '*', element: <Navigate to="/not-found" replace /> }
]
